/**
 * Environment variables configuration
 */

interface Environment {
  apiBaseUrl: string;
  apiTimeout: number;
  tenantId: string;
  enableRealtime: boolean;
  enableAnalytics: boolean;
  logLevel: 'debug' | 'info' | 'warn' | 'error';
  isDevelopment: boolean;
  isProduction: boolean;
}

const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[`VITE_${key}`];
  if (!value && defaultValue === undefined) {
    console.warn(`Environment variable VITE_${key} not found`);
  }
  return value || defaultValue || '';
};

export const env: Environment = {
  apiBaseUrl: getEnvVar('API_BASE_URL'),
  apiTimeout: parseInt(getEnvVar('API_TIMEOUT', '30000'), 10),
  tenantId: getEnvVar('TENANT_ID', '1'),
  enableRealtime: getEnvVar('ENABLE_REALTIME', 'false') === 'true',
  enableAnalytics: getEnvVar('ENABLE_ANALYTICS', 'false') === 'true',
  logLevel: (getEnvVar('LOG_LEVEL', 'info') as any) || 'info',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};
